module.exports = __webpack_public_path__ + "static/1.2.B.3 CASA MERCEA RANDARE 3-a1315b3504647ab78c461b093d8bb070.jpg";